<template>
  <div class="right-panel">
    <BarChart
      v-if="$store.state.chinaMap.currentlyMapAdcode"
      style="height: 50%"
    />
    <TotalQuantity style="height: 50%" />
    <serviceRanking v-if=" $store.state.chinaMap.dataType == 3" style="height: 50%" />
    <priceTrend
      v-if="
        !$store.state.chinaMap.currentlyMapAdcode &&
        $store.state.chinaMap.dataType !== 3
      "
      style="height: 50%"
    />
  </div>
</template>
<script>
import BarChart from './BarChart.vue';
import TotalQuantity from '@/views/ChinaMapData/components/body/right/totalQuantity.vue';
import priceTrend from '@/views/ChinaMapData/components/body/right/priceTrend.vue';
import serviceRanking from '@/views/ChinaMapData/components/body/right/serviceRanking.vue'
export default {
  name: 'RightPanel',
  components: { BarChart, TotalQuantity, priceTrend,serviceRanking },
};
</script>

<style scoped>
.right-panel {
  width: 25%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
